import { Component, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { EventsService } from '../Events.service';

const icon_expand:string = "keyboard_arrow_down";
const icon_collapse:string =  "keyboard_arrow_up";

@Component({
    selector: 'expand-panel',
    template: require('./expandpanel.component.html')
})



export class ExpandPanelComponent {
    
      public isExpanded:boolean = false;
      public arrow_icon:string = icon_expand;

      @Input() panelTitle = "This is my title";
      @Input() parent: boolean = false;
      
      error: any;
 
    constructor(private elRef: ElementRef,private _eventsService: EventsService) { 

        _eventsService.searchInvoked$.subscribe(
            search => {
              this.isExpanded = false;
              this.arrow_icon  = icon_expand;

            }

        );
        
    }

    
    ngOnInit() {

     
    }

    ngOnDestroy() {

    }

    //handle the expand/close events
    expandClick() {

        this.isExpanded ? this.isExpanded = false : this.isExpanded = true;
        this.isExpanded ? this.arrow_icon = icon_collapse : this.arrow_icon = icon_expand;


    }
}


// WEBPACK FOOTER //
// ./app/shared/expand-panel/expandpanel.component.ts